import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import FirstCard from '../../../assets/newAssets/company-logo/first_card.svg';
import SecondCard from '../../../assets/newAssets/company-logo/second_card.svg';
import ThirdCard from '../../../assets/newAssets/company-logo/third_card.svg';
import Leaf1 from '../../../assets/newAssets/company-logo/leaf-1.png';
import Leaf2 from '../../../assets/newAssets/company-logo/leaf-2.png';
import { FormattedMessage } from 'react-intl';
import ReactDOM from 'react-dom';
import { OrangeBtn } from '../../../newComponents/Button/ButtonSkin';
import { useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';

const Container = styled.div`
    position: relative;
    isolation: isolate;
    overflow: visible;
    overflow-x: clip;
    display: flex;
    padding: 110px 80px;
    flex-direction: column;
    align-items: center;
    gap: 60px;
    background: var(--Regenera-BG-Light-Green, #f8fbf6);

    @media (max-width: 768px) {
        padding: 3rem 1rem;
    }
`;

const MaxWidthWrapper = styled.div`
    position: relative;
    z-index: 1;
    max-width: 1280px;
    width: 100%;
    margin: 0 auto;
`;

const HeaderSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    align-self: stretch;
    margin-bottom: 60px;

    @media (max-width: 768px) {
        margin-bottom: 3rem;
    }
`;

const Title = styled.h1`
    color: var(--Trust-Green, #004d37);
    text-align: center;
    font-family: Montserrat;
    font-size: 32px;
    font-style: normal;
    font-weight: 500;
    line-height: 42px;

    @media (max-width: 1024px) {
        font-size: 2.5rem;
    }

    @media (max-width: 768px) {
        font-size: 2rem;
    }
`;

const Subtitle = styled.p`
    color: var(--Trust-Green, #004d37);
    text-align: center;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 180%;

    @media (max-width: 768px) {
        font-size: 1rem;
    }
`;

const CardsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1.5rem;

    @media (max-width: 1024px) {
        grid-template-columns: 1fr;
        gap: 2rem;
    }
`;

const CarouselContainer = styled.div`
    display: none;
    position: relative;
    overflow: hidden;

    @media (max-width: 1024px) {
        display: block;
    }
`;

const CarouselTrack = styled.div`
    display: flex;
    transition: transform 0.5s ease-in-out;
    transform: translateX(-${props => props.$currentIndex * 100}%);
    width: 100%;
`;

const CarouselSlide = styled.div`
    flex: 0 0 100%;
    min-width: 100%;
    box-sizing: border-box;
    padding: 0 0.5rem;
`;

const CarouselDots = styled.div`
    display: flex;
    justify-content: center;
    gap: 0.5rem;
    margin-top: 2rem;
`;

const CarouselDot = styled.button`
    width: 0.75rem;
    height: 0.75rem;
    border-radius: 50%;
    border: none;
    background-color: ${props => (props.$active ? '#004d37' : '#ddedd0')};
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
        background-color: ${props => (props.$active ? '#004d37' : '#6ea44c')};
    }
`;

const DesktopGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1.5rem;

    @media (max-width: 1024px) {
        display: none;
    }
`;

const Card = styled.div`
    border-radius: 20px;
    background: var(--Regenera-Clarity-White, #fff);
    box-shadow: 3px 3px 20px 0 rgba(0, 0, 0, 0.07);
    overflow: hidden;
`;

const ImagePlaceholder = styled.div`
    background-color: #ddedd0;
    border-radius: 0.5rem 0.5rem 0 0;
    padding: 2rem;
    height: 14rem;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
    }
`;

const CardContent = styled.div`
    display: flex;
    padding: 32px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
    @media (max-width: 768px) {
        height: 346px;
    }
`;

const CardTitle = styled.div`
    color: var(--Trust-Green, #004d37);
    font-family: Montserrat;
    font-size: 19.2px;
    font-style: normal;
    font-weight: 500;
    line-height: 27.2px;
`;

const CardDescription = styled.div`
    color: var(--Regenera-Dark-Grey, #424a46);
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 180%;
`;

const PrimaryButton = styled.button`
    width: 100%;
    background-color: #dd6b17;
    color: white;
    border: none;
    border-radius: 9999px;
    height: 3rem;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: #c55f14;
    }
`;

const SecondaryLink = styled.a`
    color: var(--Regenera-Trust-Green, #004d37);
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
    display: flex;
    align-items: center;

    &:hover {
        gap: 0.5rem;
    }

    svg {
        width: 1rem;
        height: 1rem;
    }
`;

const LeafTopImg = styled.img`
    position: absolute;
    top: -60px;
    left: 0;
    transform: translateX(-28%);
    width: clamp(90px, 16vw, 240px);
    pointer-events: none;
    user-select: none;
    z-index: 2;

    @media (max-width: 768px) {
        display: none;
    }
`;

const LeafSideImg = styled.img`
    position: absolute;
    top: 155px;
    left: 0;
    transform: translateX(-18%);
    width: clamp(30px, 10vw, 110px);
    pointer-events: none;
    user-select: none;
    z-index: 2;

    @media (max-width: 768px) {
        display: none;
    }
`;

const Overlay = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999; /* higher than any page element */
`;

const ModalBox = styled.div`
    background: #fff;
    border-radius: 20px;
    padding: 32px;
    max-width: 420px;
    width: 90%;
    text-align: center;
    box-shadow: 0 30px 80px rgba(0, 0, 0, 0.2);
`;

const ModalTitle = styled.h2`
    color: #004d37;
    font-family: Montserrat;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 12px;
`;

const ModalText = styled.p`
    color: #424a46;
    font-size: 15px;
    margin-bottom: 20px;
`;

const ModalBtn = styled.a`
    display: inline-block;
    background: #dd6b17;
    color: #fff;
    text-decoration: none;
    padding: 10px 20px;
    border-radius: 9999px;
    font-weight: 600;
    width: 100%;
    transition: background 0.2s ease;
    &:hover {
        background: #c55f14;
    }
`;

const ModalClose = styled.button`
    margin-top: 12px;
    background: none;
    border: none;
    color: #6b6b6b;
    font-size: 14px;
    cursor: pointer;
    &:hover {
        text-decoration: underline;
    }
`;
const ArrowIcon = () => (
    <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
    </svg>
);

const cardsData = [
    {
        id: 1,
        title: (
            <FormattedMessage
                id="CardsSection.firstCard.title"
                defaultMessage="Calculate your footprint"
            />
        ),
        description: (
            <FormattedMessage
                id="CardsSection.firstCard.description"
                values={{
                    br: <br />,
                }}
                defaultMessage="You can't improve what you don't know. Measure your footprint using our calculator, or request an expert-assisted calculation."
            />
        ),
        buttonText: (
            <FormattedMessage
                id="CardsSection.firstCard.button"
                defaultMessage="Calculate footprint"
            />
        ),
        secondaryLink: {
            text: (
                <FormattedMessage
                    id="CardsSection.firstCard.secondaryLink"
                    defaultMessage="Inquire for certified study"
                />
            ),
            href: 'https://calendly.com/frankhajek/30min?month=2025-10',
        },
        image: FirstCard,
    },
    {
        id: 2,
        title: (
            <FormattedMessage
                id="CardsSection.secondCard.title"
                defaultMessage="Get your roadmap to climate positivity"
            />
        ),
        description: (
            <FormattedMessage
                id="CardsSection.secondCard.description"
                defaultMessage="A successful journey needs a roadmap. Develop yours with a member of our team and agree the milestones you need to achieve."
            />
        ),
        buttonText: (
            <FormattedMessage id="CardsSection.secondCard.button" defaultMessage="Inquire here" />
        ),
        image: SecondCard,
    },
    {
        id: 3,
        title: (
            <FormattedMessage
                id="CardsSection.thirdCard.title"
                defaultMessage="Become Nature & climate positive"
            />
        ),
        description: (
            <FormattedMessage
                id="CardsSection.thirdCard.description"
                defaultMessage="All organisations have a residual footprint. Regenerate yours by supporting Nature protection and restoration actions with Regenera's Guardians"
            />
        ),
        buttonText: <FormattedMessage id="CardsSection.thirdCard.button" />,
        secondaryLink: {
            text: (
                <FormattedMessage
                    id="CardsSection.thirdCard.secondaryLink"
                    defaultMessage="Or read more about it first"
                />
            ),
            href: '/organizations',
        },
        image: ThirdCard,
    },
];

function CardComponent({
    card,
    isFirst,
    isSecond,
    isThird,
    user,
    onCalculateClick,
    onInquireClick,
}) {
    return (
        <Card>
            <ImagePlaceholder>
                <img src={card.image} alt={card.title} />
            </ImagePlaceholder>
            <CardContent>
                <CardTitle>{card.title}</CardTitle>
                <CardDescription>{card.description}</CardDescription>

                {isFirst ? (
                    <OrangeBtn as="button" onClick={onCalculateClick}>
                        <FormattedMessage id="CardsSection.firstCard.button" />
                    </OrangeBtn>
                ) : isSecond ? (
                    <OrangeBtn as="button" onClick={onInquireClick}>
                        <FormattedMessage id="CardsSection.secondCard.button" />
                    </OrangeBtn>
                ) : isThird ? (
                    <OrangeBtn as={Link} to={user ? '/subscription/signup' : '/signup/start'}>
                        {user ? 'Join now' : 'Sign up'}
                    </OrangeBtn>
                ) : (
                    <OrangeBtn>{card.buttonText}</OrangeBtn>
                )}

                {card.secondaryLink && (
                    <SecondaryLink
                        href={card.secondaryLink.href}
                        target={
                            /^https?:\/\//i.test(card.secondaryLink.href) ? '_blank' : undefined
                        }
                        rel={
                            /^https?:\/\//i.test(card.secondaryLink.href)
                                ? 'noopener noreferrer'
                                : undefined
                        }
                    >
                        {card.secondaryLink.text}
                        <ArrowIcon />
                    </SecondaryLink>
                )}
            </CardContent>
        </Card>
    );
}

export function EmailModal({ onClose }) {
    // lock scroll while open
    useEffect(() => {
        const { body } = document;
        const prev = body.style.overflow;
        body.style.overflow = 'hidden';
        return () => {
            body.style.overflow = prev;
        };
    }, []);

    const modal = (
        <Overlay onClick={onClose} role="dialog" aria-modal="true">
            <ModalBox onClick={e => e.stopPropagation()}>
                <ModalTitle>Contact Frank Hajek</ModalTitle>
                <ModalText>
                    You can reach Frank directly at <b>frank.hajek@natureservices.net</b>
                </ModalText>

                <ModalBtn href="mailto:frank.hajek@natureservices.net?subject=Inquiry about Regenera Roadmap&body=Hi Frank,%0D%0A%0D%0AI would like to learn more about the roadmap to climate positivity.%0D%0A%0D%0ABest regards,%0D%0A[Your Name]">
                    Open Email App
                </ModalBtn>

                <ModalClose onClick={onClose}>Cancel</ModalClose>
            </ModalBox>
        </Overlay>
    );

    return ReactDOM.createPortal(modal, document.body);
}

export default function ClimatePositiveSection({ user }) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [showEmailModal, setShowEmailModal] = useState(false);
    const currentRole =
        useSelector(s => s.user && s.user.currentUser && s.user.currentUser.currentRole) ||
        'friend';
    const activatedRoles =
        useSelector(s => s.user && s.user.currentUser && s.user.currentUser.activatedRoles) || [];

    const isPartner = currentRole === 'partner';

    const history = useHistory();
    const FRIEND_CALC_URL = '/people/personal-footprint-calculator';
    const ORG_CALC_URL = '/organisation/calculator';
    const PUBLIC_CALC_URL = '/calculator';
    const BRIAN_CALENDLY_URL = 'https://calendar.app.google/mcvHNEBgBqBBRXG68';

    const handleCalculateClick = e => {
        e.preventDefault();
        if (user) {
            const hasPartner = activatedRoles.includes('partner');
            const isOnPartner = currentRole === 'partner';

            if (hasPartner && isOnPartner) {
                // Logged in, partner activated, currently on partner → org calculator
                history.push(ORG_CALC_URL);
            } else {
                // Logged in but partner not activated OR on friend role → friend calculator
                history.push(FRIEND_CALC_URL);
            }
        } else {
            // Not logged in → public calculator
            history.push(PUBLIC_CALC_URL);
        }
    };

    const handleInquireClick = e => {
        e.preventDefault();
        setShowEmailModal(true);
    };
    useEffect(() => {
        const timer = setInterval(
            () => setCurrentIndex(prevIndex => (prevIndex + 1) % cardsData.length),
            5000
        );
        return () => clearInterval(timer);
    }, []);

    const handleDotClick = index => setCurrentIndex(index);

    return (
        <Container>
            <LeafTopImg src={Leaf1} alt="" aria-hidden="true" />
            <LeafSideImg src={Leaf2} alt="" aria-hidden="true" />
            <MaxWidthWrapper>
                <HeaderSection>
                    <Title>
                        <FormattedMessage
                            id="ClimatePositiveSection.title"
                            values={{
                                br: <br />,
                            }}
                        />
                    </Title>
                    <Subtitle>
                        <FormattedMessage
                            id="ClimatePositiveSection.subtitle"
                            defaultMessage="Every organisation can take action, regardless of their starting point."
                        />
                    </Subtitle>
                </HeaderSection>

                <DesktopGrid>
                    {cardsData.map(card => (
                        <CardComponent
                            key={card.id}
                            card={card}
                            isFirst={card.id === 1}
                            isSecond={card.id === 2}
                            isThird={card.id === 3}
                            user={user}
                            onCalculateClick={handleCalculateClick}
                            onInquireClick={handleInquireClick}
                        />
                    ))}
                </DesktopGrid>

                <CarouselContainer>
                    <CarouselTrack $currentIndex={currentIndex}>
                        {cardsData.map(card => (
                            <CarouselSlide key={card.id}>
                                <CardComponent
                                    card={card}
                                    isFirst={card.id === 1}
                                    isSecond={card.id === 2}
                                    isThird={card.id === 3}
                                    user={user}
                                    onCalculateClick={handleCalculateClick}
                                    onInquireClick={handleInquireClick}
                                />
                            </CarouselSlide>
                        ))}
                    </CarouselTrack>
                    <CarouselDots>
                        {cardsData.map((_, index) => (
                            <CarouselDot
                                key={index}
                                $active={index === currentIndex}
                                onClick={() => handleDotClick(index)}
                                aria-label={`Go to slide ${index + 1}`}
                            />
                        ))}
                    </CarouselDots>
                </CarouselContainer>
            </MaxWidthWrapper>
            {showEmailModal && <EmailModal onClose={() => setShowEmailModal(false)} />}
        </Container>
    );
}
